import React, { useContext, useEffect, useState } from 'react'
import Chart from "react-apexcharts";
import AlertsComp from '../../../Components/AlertsComp';
import { formatDateToMMDDYYYY, patchAxisTitles } from '../../../JS/Common';
import { UserContext } from '../../../App';
import useConfig from '../../../Hooks/useConfig';

export default function OpenHelpdeskTicketsbyBuilding(props) {
    const { user_no, decimalRange } = useConfig();
    const { UserData } = useContext(UserContext);
    var vData = props?.AllReportData?.data;
    const [series, setSeries] = useState([]);
    const [chartLoaded, setChartLoaded] = useState(false);

    var categories = []
    categories = vData?.categories?.length > 0 ? vData?.categories : [];

    useEffect(() => {
        const newSeries = vData?.series?.map(value => parseFloat(value)?.toFixed(decimalRange)) || [];
        setSeries(newSeries);
        setChartLoaded(true);
    }, [vData]);

    const options1 = {
        chart: {
            height: 400,
            type: "bar",
            toolbar: {
                show: false,
            },
            events: {
                mounted(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(categories, chartContext.el);
                    });
                },
                updated(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(categories, chartContext.el);
                    });
                },
                resized(chartContext) {
                    requestAnimationFrame(() => {
                        patchAxisTitles(categories, chartContext.el);
                    });
                }
            }
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top",
                },
            },
        },
        xaxis: {
            categories: categories,
            title: {
                text: "Building",
            },
            labels: {
                formatter: function (value) {
                    if (!value) return value;
                    if (value.length > 25) {
                        return value.substring(0, 15) + '...';
                    }
                    return value;
                },
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return parseFloat(val)?.toFixed(decimalRange);
                },
            },
            title: {
                text: "No of Ticket",
                style: {
                    fontSize: '14px',
                    fontWeight: 600,
                },
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
                fontSize: '11px',
            },
        },
        colors: ["#92b5e4"],
        tooltip: {
            x: {
                formatter: function (val, { dataPointIndex }) {
                    // Show full building name on hover
                    return vData?.categories?.[dataPointIndex] || val;
                }
            },
            y: {
                formatter: function (val) {
                    return "Total Tickets: " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
        grid: {
            padding: {
                bottom: 20,
                left: 10,
                right: 10,
            },
        },
    };
    const downloadCsv = () => {
        const csvContent = [];
        const gradeMap = new Map();
        vData?.pdf_data?.forEach((buildingTickets) => {
            if (buildingTickets.length > 0) {
                const building = buildingTickets[0]?.building?.name || buildingTickets[0]?.other_building_name || '-' // Get the building name
                if (!gradeMap.has(building)) {
                    gradeMap.set(building, []);
                }
                buildingTickets.forEach((ticket) => {
                    const rowData = {
                        'Ticket Number': ticket.request_num || ticket.support_ticket_num,
                        'Subject': ticket.title,
                        'Name': ticket?.name,
                        'Email': ticket?.email,
                        'Room': ticket?.room_name ? ticket?.room_name : ticket.room ? ticket?.room?.name : '-',
                        [user_no]: ticket?.student_no || ticket?.student_num,
                        'Created at': ticket.created_at ? formatDateToMMDDYYYY(ticket.created_at) : '-',  // Format the date
                        'Assigned To': ticket?.assigned_flag == 1 ?
                            ticket?.usergroup?.name :
                            ticket?.assigned_flag == 2 ?
                                `${ticket?.user?.first_name} ${ticket?.user?.last_name}`
                                : ticket?.user ? `${ticket?.user?.first_name} ${ticket?.user?.last_name}` : '-',
                        'Help Desk Type': ticket?.type?.name,  // Format the date
                    };

                    // Push the row data to the map for the current building
                    gradeMap.get(building).push(rowData);
                });
            }
        });


        gradeMap.forEach((gradeData, building) => {
            csvContent.push([`Building: ${building}`]);
            const headers = ['Ticket Number', 'Subject', 'Name', 'Email', 'Room', user_no, 'Created at', 'Assigned To', 'Help Desk Type'];
            csvContent.push(headers);
            gradeData.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
            csvContent.push([]);
        });

        if (csvContent.length > 0) {
            const csvString = csvContent.map(row => row.join(',')).join('\n'); // Convert to CSV string
            const blob = new Blob([csvString], { type: 'text/csv' });  // Create a Blob with the CSV content
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'OpenHelpdeskTickets.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            props.setAlerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
            setTimeout(() => {
                props.setAlerts(<AlertsComp show={false} />)
            }, 1500);
        }
    };
    return (
        <div className="text-center h-100 greyBox">
            <div className="pb-5 w-100">
                <div className='row'>
                    <h4>
                        {UserData.helpdeskUpdatedFlag ? "Open Help Desk Ticket Report by Building" :
                            "Open Support Ticket Report by Building"}
                    </h4>
                </div>
                <div className='justify-content-center d-flex mb-3'>
                    <label className='cursor-pointer d-flex align-items-center' onClick={downloadCsv} style={{ fontSize: "12px" }}>
                        <img src="/images/downloadPlan.svg" className="pe-1" title='Download CSV' height='10px' />
                        <label className='cursor-pointer'>Download Detailed Reports</label>
                    </label>
                </div>
                {props?.AllReportData?.loder == true ?
                    <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div>
                    :
                    <div id="chart">
                        {chartLoaded && vData?.categories?.length > 0 && series?.length > 0 ? (
                            <Chart
                                options={options1}
                                series={[{ data: series }]}
                                type="bar"
                                height={450}
                                id="helpdesk-ticket-chart"
                            />
                        ) : (
                            <div className="text-center pt-3">No data available</div>
                        )}

                    </div>
                }
            </div>
        </div>
    )
}
